// extracted by mini-css-extract-plugin
module.exports = {"root":"FieldCheckboxGroup_root__3TZ0H","list":"FieldCheckboxGroup_list__2nYCo","twoColumns":"FieldCheckboxGroup_twoColumns__24ENC","item":"FieldCheckboxGroup_item__37YFz"};